// app/javascript/config/i18n.ts
import { I18n } from 'i18n-js'

import translations from '../translations.json'

const i18n = new I18n()
export default i18n
i18n.store(translations)
i18n.defaultLocale = 'de'
i18n.enableFallback = true
